import { useAuthStore } from "@/stores/auth";
import { useAdminOrgStore } from "@/stores/admin-org";
import { useClaims } from "@/hooks/use-claims";

export function useApiHeaders(): Record<string, string> {
  const session = useAuthStore((s) => s.session);
  const { isPlatformAdmin } = useClaims();
  const adminOrgId = useAdminOrgStore((s) => s.orgId);

  const headers: Record<string, string> = {
    Authorization: `Bearer ${session?.access_token ?? ""}`,
    "Content-Type": "application/json",
  };

  if (isPlatformAdmin && adminOrgId) {
    headers["X-Org-Id"] = adminOrgId;
  }

  return headers;
}
